import type { TastingExperienceFormErrors } from './types';
import { FormSection } from '../ui/FormSection';

export interface ExperiencePricingFieldsProps {
  priceAmount: string;
  onPriceAmountChange: (value: string) => void;
  duration: string;
  onDurationChange: (value: string) => void;
  errors: TastingExperienceFormErrors;
  touched: Record<string, boolean>;
  onBlur: (field: string) => void;
  isSubmitting: boolean;
}

export const ExperiencePricingFields = ({
  priceAmount,
  onPriceAmountChange,
  duration,
  onDurationChange,
  errors,
  touched,
  onBlur,
  isSubmitting,
}: ExperiencePricingFieldsProps) => (
  <FormSection title="Pricing and Duration">
    {/* Price */}
    <div>
      <label htmlFor="price" className="block text-sm font-medium text-gray-700 mb-1">
        Price (USD) <span className="text-red-500">*</span>
      </label>
      <div className="relative">
        <span className="absolute left-3 top-2 text-gray-500">$</span>
        <input
          id="price"
          type="text"
          inputMode="decimal"
          value={priceAmount}
          onChange={(e) => onPriceAmountChange(e.target.value)}
          onBlur={() => onBlur('price')}
          disabled={isSubmitting}
          placeholder="0.00"
          className={`w-full pl-8 pr-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-info-500 ${
            touched.price && errors.price ? 'border-red-500' : 'border-gray-300'
          } ${isSubmitting ? 'bg-gray-100 cursor-not-allowed' : ''}`}
        />
      </div>
      {touched.price && errors.price && <p className="mt-1 text-sm text-red-600">{errors.price}</p>}
    </div>

    {/* Duration */}
    <div>
      <label htmlFor="duration" className="block text-sm font-medium text-gray-700 mb-1">
        Duration (minutes)
      </label>
      <input
        id="duration"
        type="text"
        inputMode="numeric"
        value={duration}
        onChange={(e) => onDurationChange(e.target.value)}
        onBlur={() => onBlur('duration')}
        disabled={isSubmitting}
        placeholder="e.g., 60"
        className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-info-500 ${
          touched.duration && errors.duration ? 'border-red-500' : 'border-gray-300'
        } ${isSubmitting ? 'bg-gray-100 cursor-not-allowed' : ''}`}
      />
      {touched.duration && errors.duration && (
        <p className="mt-1 text-sm text-red-600">{errors.duration}</p>
      )}
    </div>
  </FormSection>
);
